"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAccordionStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeAccordionStyles = function makeAccordionStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  var borderRadius = primitives.borderRadii.large;
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&::before": {
            background: "none"
          },
          margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"]),
          "&.Mui-expanded": {
            margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"]),
            "&:hover": {
              background: tokens.colors["ink-on-fill-primary"].rgb
            },
            "&:active": {
              background: tokens.colors["ink-on-fill-primary"].rgb
            }
          },
          "&:first-of-type": {
            marginTop: primitives.spacings["0"]
          },
          "&:last-child": {
            marginBottom: primitives.spacings["0"]
          },
          "&:focus, &:focus-visible, &:focus-within": {
            zIndex: 1
          },
          "&.Mui-disabled": {
            backgroundColor: "initial",
            "&:hover": {
              background: tokens.colors["ink-on-fill-primary"].rgb
            },
            "&:focus, &:focus-visible, &:focus-within": {
              boxShadow: "unset"
            },
            "&:active": {
              background: tokens.colors["ink-on-fill-primary"].rgb
            }
          },
          "&.DhigAccordion--size--normal": {
            '& [class*="MuiAccordionSummary-root"]': {
              padding: "".concat(primitives.spacings["6"], " ").concat(primitives.spacings["5"], " ").concat(primitives.spacings["6"], "  ").concat(primitives.spacings["6"])
            },
            '& [class*="MuiAccordionDetails-root"]': {
              padding: "0 ".concat(primitives.spacings["6"], " ").concat(primitives.spacings["7"], " ").concat(primitives.spacings["6"])
            }
          },
          "&.DhigAccordion--size--dense": {
            '& [class*="MuiAccordionSummary-root"]': {
              padding: "".concat(primitives.spacings["4"])
            },
            '& [class*="MuiAccordionDetails-root"]': {
              padding: "0 ".concat(primitives.spacings["4"], " ").concat(primitives.spacings["6"], " ").concat(primitives.spacings["4"])
            }
          },
          "&.DhigAccordion--styleVariant--individualPanel": {
            boxShadow: tokens.effects["container-0"].boxShadow,
            "&:focus, &:focus-visible, &:focus-within": {
              '& [class*="MuiAccordionSummary-root"]': {
                borderRadius: borderRadius
              }
            }
          },
          "&.DhigAccordion--styleVariant--individualPanel.Mui-expanded": {
            boxShadow: tokens.effects["container-1"].boxShadow,
            "&:focus, &:focus-visible": {
              border: "unset"
            }
          },
          "&.DhigAccordion--styleVariant--flat:first-of-type": {
            borderTop: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"].rgb)
          },
          "&.DhigAccordion--styleVariant--flat": {
            borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"].rgb),
            margin: 0,
            '& [class*="MuiAccordionSummary-root"]': {
              paddingLeft: primitives.spacings["4"],
              paddingRight: primitives.spacings["0"],
              "&::before, &::after": {
                borderRadius: primitives.spacings["0"]
              }
            },
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: primitives.spacings["0"],
              paddingRight: primitives.spacings["0"]
            },
            "&:not(:focus):not(:focus-visible):not(:focus-within)": {
              '& [class*="MuiAccordionSummary-root"]': {
                paddingLeft: primitives.spacings["0"],
                paddingRight: primitives.spacings["0"]
              },
              '& [class*="MuiAccordionDetails-root"]': {
                paddingLeft: primitives.spacings["0"]
              }
            },
            "&:focus-within": {
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible)': {
                paddingLeft: primitives.spacings["0"]
              },
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible) ~ [class*="MuiCollapse-root"] [class*="MuiAccordionDetails-root"]': {
                paddingLeft: primitives.spacings["0"]
              }
            }
          },
          "&.DhigAccordion--styleVariant--mergedPanel:last-of-type": {
            border: primitives.spacings["0"],
            borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.detail["slate-dark"]),
            borderBottomLeftRadius: primitives.spacings["2"],
            borderBottomRightRadius: primitives.spacings["2"],
            boxShadow: "0px 0px 0px 1px ".concat(tokens.colors["detail-1-opaque"].rgb, " inset, 0px -1px 0px 0px ").concat(tokens.colors["detail-2-opaque"].rgb, " inset")
          },
          "&.DhigAccordion--styleVariant--mergedPanel:first-of-type": {
            borderTopLeftRadius: primitives.spacings["2"],
            borderTopRightRadius: primitives.spacings["2"]
          },
          "&.DhigAccordion--styleVariant--mergedPanel": {
            border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"].rgb),
            borderBottom: primitives.spacings["0"],
            borderRadius: primitives.spacings["0"],
            margin: primitives.spacings["0"],
            "&:focus, &:focus-visible, &:focus-within": {
              '& [class*="MuiAccordionSummary-root"]': {
                borderRadius: borderRadius
              }
            },
            "&:active": {
              background: "linear-gradient(270deg, rgba(43, 194, 117, 0.15) 0%, rgba(43, 194, 117, 0) 100%)"
            }
          },
          "&.DhigAccordion--styleVariant--minimal": {
            border: "none",
            margin: primitives.spacings["0"],
            '& [class*="MuiAccordionSummary-root"]': {
              paddingLeft: primitives.spacings["4"],
              paddingRight: primitives.spacings["3"],
              "&::before, &::after": {
                borderRadius: primitives.spacings["0"]
              }
            },
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: primitives.spacings["0"],
              paddingRight: primitives.spacings["0"]
            },
            "&:not(:focus):not(:focus-visible):not(:focus-within)": {
              '& [class*="MuiAccordionSummary-root"]': {
                paddingLeft: primitives.spacings["0"],
                paddingRight: primitives.spacings["3"]
              }
            },
            "&:focus-within": {
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible)': {
                paddingLeft: primitives.spacings["0"]
              },
              '& [class*="MuiAccordionSummary-root"]:focus:not(:focus-visible) ~ [class*="MuiCollapse-root"] [class*="MuiAccordionDetails-root"]': {
                paddingLeft: primitives.spacings["0"]
              }
            },
            "&.Mui-disabled": {
              boxShadow: "none"
            }
          },
          "&.DhigAccordion--type--stepper": {
            '& [class*="MuiAccordionSummary-root"]': {
              "&::before, &::after": {
                borderRadius: primitives.spacings["0"]
              }
            },
            '& [class*="DhigAccordionSummary--title"]': {
              "& svg": {
                fontSize: primitives.spacings["7"],
                marginRight: primitives.spacings["3"]
              }
            },
            '& [class*="MuiAccordionSummary-expandIconWrapper"]': {
              transform: "none",
              "& button": {
                padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
                minWidth: "auto",
                fontSize: primitives.fontSizes["2"],
                height: "fit-content"
              }
            }
          },
          "&.DhigAccordion--size--normal.DhigAccordion--type--stepper": {
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: "calc(".concat(primitives.spacings["6"], " + ").concat(primitives.spacings["7"], " + ").concat(primitives.spacings["3"], ")")
            }
          },
          "&.DhigAccordion--size--dense.DhigAccordion--type--stepper": {
            '& [class*="MuiAccordionDetails-root"]': {
              paddingLeft: "calc(".concat(primitives.spacings["4"], " + ").concat(primitives.spacings["7"], " + ").concat(primitives.spacings["3"], ")")
            }
          }
        },
        rounded: {
          borderRadius: borderRadius,
          "&:first-of-type": {
            borderTopLeftRadius: borderRadius,
            borderTopRightRadius: borderRadius
          },
          "&:last-child": {
            borderBottomLeftRadius: borderRadius,
            borderBottomRightRadius: borderRadius
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          minHeight: primitives.spacings["0"],
          backgroundColor: "initial"
        }, tokens.transitions["state-blur"]), {}, {
          zIndex: 1,
          "&::before, &::after": _objectSpread(_objectSpread({
            content: "''",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: "-1",
            opacity: 0
          }, tokens.transitions["state-blur"]), {}, {
            borderRadius: borderRadius
          }),
          "&::before": _objectSpread({
            background: "linear-gradient(270deg, rgba(128, 128, 255, 0.2) 0%, rgba(128, 128, 255, 0) 100%)"
          }, tokens.transitions["state-activate"]),
          "&::after": _objectSpread({
            background: "linear-gradient(270deg, rgba(43, 194, 117, 0.15) 0%, rgba(43, 194, 117, 0) 100%)"
          }, tokens.transitions["state-activate"]),
          "&.Mui-expanded": {
            backgroundColor: "initial",
            minHeight: primitives.spacings["0"]
          },
          "&:hover:not(:active)::before": {
            opacity: 1
          },
          "&:focus": _objectSpread({
            boxShadow: tokens.effects["focus-ring-thin"].boxShadow
          }, tokens.transitions["state-activate"]),
          "&:focus:not(:focus-visible)": {
            boxShadow: "none"
          },
          "&:focus-visible": _objectSpread({
            boxShadow: tokens.effects["focus-ring-thin"].boxShadow
          }, tokens.transitions["state-activate"]),
          "&:active::after": {
            opacity: 1
          },
          "&.Mui-focused, &.Mui-focusVisible": {
            backgroundColor: "transparent"
          }
        }),
        content: {
          margin: primitives.spacings["0"],
          "&.Mui-expanded": {
            margin: primitives.spacings["0"]
          },
          "& .DhigAccordionSummary--title": {
            margin: primitives.spacings["0"],
            color: tokens.colors["ink-on-background"].rgb,
            fontWeight: primitives.fontWeights.stout,
            lineHeight: primitives.lineHeights.compact
          }
        },
        expandIconWrapper: {
          '& [class*="MuiSvgIcon-root"]': {
            color: tokens.colors["ink-on-background"].rgb,
            fontSize: primitives.spacings["6"]
          }
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          flexDirection: "column",
          color: tokens.colors["text-on-background"].rgb
        }
      }
    }
  };
};

exports.makeAccordionStyles = makeAccordionStyles;